export type CaseType = 'lower' | 'capital';

export const textTransform = (text: string, caseType: CaseType) => {
  switch (caseType) {
    case 'lower':
      return text.toLowerCase();
    case 'capital':
      return text.replace(/\b\w/g, (char) => char.toUpperCase());
    default:
      return text;
  }
};
